const en = {
  nav: {
    home: 'Home',
    projects: 'Projects',
    experience: 'Experience',
    skills: 'Skills',
    aiLab: 'AI Lab',
    connect: 'Connect',
  },
  landing: {
    downloadResume: 'Download Resume',
  },
  projects: {
    eyebrow: 'Selected Work',
    title: 'Featured Projects',
    viewDetails: 'View Project →',
    viewAll: 'View All Projects →',
    archiveEyebrow: 'Portfolio Archive',
    archiveTitle: 'All Projects',
    filterAll: 'All',
    filterByTag: 'Filter by tag',
    sortNewest: 'Newest First',
    sortOldest: 'Oldest First',
    sortTitle: 'By Title',
    countLabel: 'Projects',
    noFound: 'No projects found.',
    backToTop: 'Back to Top',
  },
  works: {
    eyebrow: 'Career',
    title: 'Work Experience',
    viewDetails: 'View Details →',
  },
  skills: {
    eyebrow: 'Technical',
    title: 'Skills & Tools',
    languages: 'Languages',
    tools: 'Tools & Infrastructure',
    frameworks: 'Frameworks',
    exploring: 'Exploring',
  },
  education: {
    eyebrow: 'Academic',
    title: 'Education',
  },
  contact: {
    eyebrow: 'Get in Touch',
    title: 'Contact Me',
    subtitle: 'Have a project in mind? Let\'s talk.',
    nameLabel: 'Name',
    namePlaceholder: 'Your name',
    emailLabel: 'Email',
    subjectLabel: 'Subject',
    subjectPlaceholder: 'What\'s this about?',
    messageLabel: 'Message',
    messagePlaceholder: 'Tell me about your project...',
    submit: 'Send Message',
  },
  chat: {
    title: 'AI Assistant',
    subtitle: "About Yu-An's portfolio",
    welcome: "Hi! I can answer questions about Yu-An's experience, projects, and skills.",
    placeholder: 'Ask a question... (Enter to send)',
    stopTitle: 'Stop generating',
    stop: 'Stop',
    clearTitle: 'Clear chat',
    clear: 'Clear',
  },
  aiLab: {
    title: 'AI Lab',
    subtitle: 'AI-powered tools built into this portfolio. Explore how my experience matches your needs.',
    jdAnalyzerDesc: 'Paste a job description to instantly analyze how my experience, projects, and skills align with your requirements. Powered by Retrieval-Augmented Generation.',
    openJDAnalyzer: 'Open JD Analyzer',
    pinLabel: 'Enter PIN',
    pinError: 'Incorrect PIN',
    devMode: 'Developer Mode',
  },
  jdAnalyzer: {
    badge: 'AI-Powered Matching',
    title: 'JD Analyzer',
    subtitle: "Paste a job description to analyze the candidate's fit using Retrieval-Augmented Generation (RAG).",
    inputLabel: 'Job Description',
    clearTooltip: 'Clear text',
    placeholder: 'Paste the job requirements, responsibilities, and qualifications here...',
    analyze: 'Start Analysis',
    stop: 'Stop Analysis',
    reportTitle: 'Analysis Report',
    generating: 'Generating...',
    proTip: 'Pro-tip: Relevant projects mentioned in the report will be highlighted in the portfolio.',
  },
};

export default en;
